import { Link } from "react-router-dom";

export default function CtaBanner() {
  return (
    <section className="mx-auto max-w-[1200px] px-4 pb-4 md:px-8" aria-labelledby="cta-heading">
      <div className="relative isolate overflow-hidden rounded-lg">
        <div className="absolute inset-0" aria-hidden="true">
          <img
            src="https://readdy.ai/api/search-image?query=Abstract%20artistic%20close%20up%20of%20old%20typewriter%20keys%20and%20paper%20documents%20in%20warm%20moody%20light%2C%20deep%20crimson%20and%20amber%20tones%2C%20cinematic%20low%20key%20texture%2C%20documentary%20editorial%20concept%2C%20no%20text&width=1400&height=560&seq=cta-ink-desk&orientation=landscape"
            alt="打字机与纸张文件在暖色灯光下，象征线索与求证"
            title="向拾真社提供线索"
            className="h-full w-full object-cover object-top"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/92 via-foreground-950/78 to-foreground-950/45" aria-hidden="true"></div>

        <div className="relative grid grid-cols-1 gap-8 px-6 py-12 md:grid-cols-[1.4fr_1fr] md:items-center md:px-12 md:py-16">
          <div>
            <p className="font-label text-[11px] uppercase tracking-[0.2em] text-accent-400">线索征集</p>
            <h2 id="cta-heading" className="mt-4 font-heading text-2xl font-bold leading-snug text-background-50 md:text-3xl">
              你手里的一段录像、一张单据，可能正是缺的那块拼图
            </h2>
            <p className="mt-4 max-w-xl text-sm leading-relaxed text-background-200">
              我们接受匿名投稿，会对来源信息脱敏处理。如果材料不足以支撑结论，我们会如实说明，而不是把它包装成爆点。
            </p>
            <div className="mt-7 flex flex-col gap-3 sm:flex-row">
              <Link
                to="/contact"
                className="inline-flex items-center justify-center gap-2 rounded-md bg-accent-500 px-6 py-3 text-sm font-medium text-foreground-950 transition-colors hover:bg-accent-600 whitespace-nowrap"
              >
                <i className="ri-send-plane-line" aria-hidden="true"></i>
                提交线索
              </Link>
              <Link
                to="/about"
                className="inline-flex items-center justify-center gap-2 rounded-md border border-background-50/30 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10 whitespace-nowrap"
              >
                了解内容原则
              </Link>
            </div>
          </div>

          <ul className="space-y-3">
            {[
              { icon: "ri-lock-line", text: "匿名投稿，来源信息脱敏处理" },
              { icon: "ri-file-shield-2-line", text: "材料只用于求证，不作二次交易" },
              { icon: "ri-chat-check-line", text: "结论有依据，证据不足会如实标注" },
            ].map((item) => (
              <li key={item.text} className="flex items-center gap-3 rounded-md border border-background-50/15 bg-background-50/8 px-4 py-3 backdrop-blur-sm">
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-accent-500/20 text-accent-400">
                  <i className={`${item.icon} text-[16px]`} aria-hidden="true"></i>
                </span>
                <span className="text-[13px] text-background-100">{item.text}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}